import React, { Children } from 'react';
import { TextAlignment } from '@philips-internal/oswald-ui-constants';
import { MessageService, ModelService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { classNames, isEnumValid } from '@philips-internal/oswald-ui-utils';
import { hideSensitiveData } from '../../utils/hide-sensitive-data.js';
import { TooltipTrigger } from '../tooltip/tooltip-constants.js';
import { Tooltip } from '../tooltip/tooltip.js';
import { TextFontFamily, TextFontSize, TextType } from './text-constants.js';
import { TextProperties } from './text-types.js';
import './text.css';
function getTextValue(props) {
    const { children, formatters } = props;
    if (Children.count(children) === 1 && typeof children === 'string') {
        return String(ModelService.formatProps(props, ['children'], formatters).children);
    }
    const { value } = ModelService.formatProps(props, ['value'], formatters);
    return value ?? '';
}
function Text(props) {
    const { alignment = TextProperties.alignment.defaultValue, bold, disableTranslation, ellipsis, family = TextProperties.family.defaultValue, sensitiveData = TextProperties.sensitiveData.defaultValue, signalColor = TextProperties.signalColor.defaultValue, signalShade = TextProperties.signalShade.defaultValue, size = TextProperties.size.defaultValue, strikethrough, type = TextProperties.type.defaultValue, uppercase, } = props;
    const className = classNames({
        'c-text': true,
        'c-text--ellipsis': Boolean(ellipsis),
        'c-text--uppercase': Boolean(uppercase),
        [`c-text--${family}`]: isEnumValid(TextFontFamily, family),
        [`c-text--${size}`]: isEnumValid(TextFontSize, size),
        [`c-text--${type}`]: isEnumValid(TextType, type),
        'u-text-bold': Boolean(bold),
        'u-text-strikethrough': Boolean(strikethrough),
        [`u-text-${alignment}`]: isEnumValid(TextAlignment, alignment),
        [`${props.className}`]: Boolean(props.className),
    });
    const style = {};
    if (type === TextType.SIGNAL) {
        style.color = `hsl(var(--color-${signalColor}-${signalShade}))`;
    }
    let textValue = getTextValue(props);
    textValue = disableTranslation ? textValue : MessageService.translate(textValue);
    textValue = hideSensitiveData(textValue, sensitiveData);
    return (React.createElement(Tooltip, { triggers: [TooltipTrigger.ELLIPSIS], value: textValue },
        React.createElement("div", { className: className, role: "paragraph", style: style }, textValue)));
}
export { Text, };
//# sourceMappingURL=text.js.map